<template>
  <v-card-text>
    <comments
      :attach-name-folder="`incident-${incidentId}`"
      attach-main-folder="Операційні ризики"></comments>
  </v-card-text>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Comments from '@/components/comments/v2/Comments.vue'

defineOptions({
  name: 'IncidentComments',
})

const route = useRoute()
const incidentId = computed(() => Number(route.params.id))
</script>
